<template>
  <div class="grid">
		<div class="col-12">
            <div class="card" v-if="permission?.includes('read')">
                <Toast/>
                <Message ref="message" severity="error" :closable="true" v-if="errors.length">{{errors}}</Message>

                <Fieldset legend="Tambah Baru" :toggleable="true" :collapsed="true" class="mb-3" v-if="permission.includes('create')">
                    <div class="p-fluid">
                        <div class="formgrid grid">
                            <div class="field col-12 md:col-6 lg:col-3">
                                <label for="username">Username</label>
                                <InputText id="username" v-model="forms.username"   :class="{ 'p-invalid': errorAdd.userweb_username }" />
                                <small class="p-invalid" style="color: red" v-if="errorAdd.userweb_username" >{{ errorAdd.userweb_username[0] }}</small >
                            </div>
                            <div class="field col-12 md:col-6 lg:col-3">
                                <label for="name">Nama</label>
                                <InputText id="name" v-model="forms.nama"   :class="{ 'p-invalid': errorAdd.userweb_nama }" />
                                <small class="p-invalid" style="color: red" v-if="errorAdd.userweb_nama" >{{ errorAdd.userweb_nama[0] }}</small>
                            </div>
                            <div class="field col-12 md:col-6 lg:col-3">
                                <label >Password</label>
                                <Password  v-model="forms.password" :feedback="false" toggleMask :class="{ 'p-invalid': errorAdd.password }" />
                                <small class="p-invalid" style="color: red" v-if="errorAdd.password" >{{ errorAdd.password[0] }}</small >
                            </div>
                            <div class="field col-12 md:col-6 lg:col-3">
                                <label for="level_id">Level</label>
                                <Dropdown id="level_id" v-model="forms.level_id" :loading="loadingDropdownLevelAdd" :options="dataDropdownLevelAdd" :class="{ 'p-invalid': errorAdd.level_id }" optionLabel="level_name" optionValue="level_id" placeholder="Pilih Level" :filter="true" :showClear="true" @filter="searchDropdownLevel($event ,'add')"/>
                                <small class="p-invalid" style="color: red" v-if="errorAdd.level_id" >{{ errorAdd.level_id[0] }}</small>
                            </div>
                        </div>
                    </div>
                    <Button :loading="loadingAddNew" label="Simpan" icon="pi pi-save" class="p-button-primary" @click="saveNew" />
                </Fieldset>

                <!-- <Fieldset legend="Filter" :toggleable="true" :collapsed="true" class="mb-3">
                    <div class="p-fluid">
                        <div class="formgrid grid">
                            <div class="field col-12 md:col-6 lg:col-3">
                                <label for="dropdownLevel">Level</label>
                                <Dropdown v-model="filters.level_id" :loading="loadingDropdownLevelFilter" :options="dataDropdownLevelFilter" optionLabel="level_name" optionValue="level_id" placeholder="Pilih Level" :filter="true" :showClear="true" @filter="searchDropdownLevel($event, 'filter')"/>
                            </div>
                        </div>
                    </div>
                    <Button :loading="loading" label="Filter" icon="pi pi-search" class="p-button-warning mr-2 my-1" @click="getDataTable" />
                </Fieldset> -->

                <DataTable :value="dataTable" responsiveLayout="scroll" :loading="loading" dataKey="cust_id" @sort="onSort($event)" >
                    <template #header>
                        <div class="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
                            <div>
                                <Button :loading="loadingExcel" label="Export Excel" icon="pi pi-file-excel" class="p-button p-button-success mr-2 my-1 inline-block" @click="exportExcelCSV('xlsx')" />
                                <Button :loading="loadingCsv" label="Export CSV" icon="pi pi-file-excel" class="p-button p-button-success mr-2 my-1 inline-block" @click="exportExcelCSV('csv')" />
                            </div>
                            <span class="block mt-2 md:mt-0 p-input-icon-left">
                                <i class="pi pi-search" />
                                <InputText v-model="search" placeholder="Cari..." @keyup.enter="getDataTable" />
                            </span>
                        </div>
                    </template>
                    <Column field="number" header="No." :style="{width:'20px'}" >
                        <template #body="slotProps">
                        {{ slotProps.data.number }}
                        </template>
                    </Column>
                    <Column field="username" header="Username">
                        <template #body="slotProps">
                            {{slotProps.data.userweb_username}}
                        </template>
                    </Column>
                    <Column field="userweb_nama" header="Nama">
                        <template #body="slotProps">
                            {{slotProps.data.userweb_nama}}
                        </template>
                    </Column>
                    <Column field="level_name" header="Level">
                        <template #body="slotProps">
                            {{slotProps.data?.level?.level_name}}
                        </template>
                    </Column>
                    <Column field="status_" header="Status">
                        <template #body="slotProps">
                            <Button icon="pi pi-check" class="p-button-rounded p-button-success" v-if="slotProps.data.status_ == '1'" />
                            <Button icon="pi pi-times" class="p-button-rounded p-button-danger" v-else/>
                        </template>
                    </Column>
					<Column header="Aksi" headerStyle="min-width:10rem;">
						<template #body="slotProps">
                            <Button icon="pi pi-refresh" class="p-button-rounded p-button-danger mr-2" @click="resetItem(slotProps.data)" v-if="permission.includes('update')"/>
							<Button icon="pi pi-pencil" class="p-button-rounded p-button-success mr-2" @click="editItem(slotProps.data)" v-if="permission.includes('update')"/>
						</template>
					</Column>
                    <template #empty>
                        No data found.
                    </template>
                    <template #loading>
                        Loading data. Please wait.
                    </template>
                    <template #footer>
                        In total there are {{totalItemsCount ? totalItemsCount : 0 }} data.
                    </template>
                </DataTable>

                <Paginator v-model:rows="rows" v-model:first="offset" :totalRecords="totalItemsCount" :rowsPerPageOptions="[10,20,30]">
                    <template>
                        {{totalItemsCount}}
                    </template>
                </Paginator>

                <Reset @submit="getDataTable()" :item="item" ref="reset"/>

				<Dialog v-model:visible="editItemDialog" :style="{width: '450px'}" header="Data Detail" :modal="true" class="p-fluid">
					<div class="field">
						<label>Username</label>
                        <InputText v-model="item.userweb_username" :class="{ 'p-invalid': errorEdit.userweb_username }" />
                        <small class="p-invalid" style="color: red" v-if="errorEdit.userweb_username" >{{ errorEdit.userweb_username[0] }}</small >
					</div>
					<div class="field">
						<label>Nama</label>
                        <InputText v-model="item.userweb_nama" :class="{ 'p-invalid': errorEdit.userweb_nama }" />
                        <small class="p-invalid" style="color: red" v-if="errorEdit.userweb_nama" >{{ errorEdit.userweb_nama[0] }}</small >
					</div>
					<div class="field">
                        <label>Level</label>
                        <Dropdown ref="dlevel" v-model="item.level_id" :loading="loadingDropdownLevelEdit" :options="dataDropdownLevelEdit" :class="{ 'p-invalid': errorEdit.level_id }" optionLabel="level_name" optionValue="level_id" placeholder="Pilih Level" :filter="true" :showClear="true" @filter="searchDropdownLevel($event,'edit')"/>
                        <small class="p-invalid" style="color: red" v-if="errorEdit.level_id" >{{ errorEdit.level_id[0] }}</small>
					</div>
                    <div class="field">
                        <label>Status</label>
                        <Dropdown ref="dstatus" v-model="item.status_"  :options="dataDropdownStatus" :class="{ 'p-invalid': errorEdit.status_ }" optionLabel="name" optionValue="code" placeholder="Pilih Status" :showClear="true"/>
                        <small class="p-invalid" style="color: red" v-if="errorEdit.status_" >{{ errorEdit.status_[0] }}</small >
                    </div>
					<div class="field">
						<label>Password</label>
                        <Password v-model="password" :class="{ 'p-invalid': errorEdit.password }" toggleMask :feedback="false" />
                        <small>Silahkan isi jika ingin mengganti password</small ><br>
                        <small class="p-invalid" style="color: red" v-if="errorEdit.password" >{{ errorEdit.password[0] }}</small >
					</div>
					<template #footer>
						<Button label="Batal" icon="pi pi-times" class="p-button-text" @click="hideDialog"/>
						<Button label="Simpan" icon="pi pi-check" class="p-button-text" @click="updateItem" :loading="loadingEdit"/>
					</template>
				</Dialog>
            </div>
      </div>
  </div>
</template>

<script>
import moment from 'moment';
import { mapGetters } from "vuex";
import { numberingDatatable } from '../../utils/helpers';
import Reset from '../../components/master/user-web/Reset.vue';

export default {
    components: {
		'Reset': Reset,
	},
    data() {
        return {
            // loading
            loading: false,
            loadingAddNew: false,
            loadingEdit: false,
            loadingDropdownLevelAdd: false,
            loadingDropdownLevelEdit: false,
            loadingDropdownLevelFilter: false,
            loadingExcel: false,
            loadingCsv: false,

            // dataDropdown
            dataDropdownLevelAdd: null,
            dataDropdownLevelEdit: null,
            dataDropdownLevelFilter: null,
            dataDropdownStatus: [
                {name: 'Aktif', code: 1},
                {name: 'Nonaktif', code: 0},
            ],

            // addNew
            forms: {
                username: null,
                password: "viewer",
                name: null,
                level_id: null,
            },

            // edit
            item: {},
            editItemDialog: false,
            password: null,
            
            // filter
            filters: {
                level_id: null,
            },

            //datatables
            data: null,
            dataTable: null,
            rows: 10,
            search: null,
            offset: null,
            field: null,
            sort: null,
            page: null,
            totalItemsCount: 0,
        }
    },
    mounted() {
        this.getDataTable();
        this.$store.commit('setErrors', {});
        this.$store.commit('setErrorAdd', {});
        this.$store.commit('setErrorEdit', {});
        this.searchDropdownLevel('');
    },
    watch: {
        offset() {
            this.getDataTable();
        },
        rows() {
            this.getDataTable();
        },
    },
    computed:{
        ...mapGetters(['errors', 'errorEdit', 'errorAdd']),
		...mapGetters("auth", ["permission"]),
    },
    methods: {
        formatDate(value){
            if (value) {
                return moment.utc(value).format('DD-MM-YYYY')
            }
        },
        // DROPDOWN
        searchDropdownLevel(event, purpose, valueEdit){
            setTimeout(() => {

                if(valueEdit){
                    this.$refs.dlevel.filterValue = valueEdit;
                }

                if(purpose == "filter"){
                    this.loadingDropdownLevelFilter = true;
                }else if(purpose == "add"){
                    this.loadingDropdownLevelAdd = true;
                }else if(purpose == "edit"){
                    this.loadingDropdownLevelEdit = true;
                }

                this.axios({
                    method: 'GET',
                    url: process.env.VUE_APP_ROOT_API + 'web/select2/level-user-web',
                    params: {
                        "search" : valueEdit ? valueEdit : event.value,
                    }
                })
                .then(res => {

                    if(purpose == "filter"){
                        this.dataDropdownLevelFilter = res.data.data;
                        this.loadingDropdownLevelFilter = false;
                    }else if(purpose == "add"){
                        this.dataDropdownLevelAdd = res.data.data;
                        this.loadingDropdownLevelAdd = false;
                    }else if(purpose == "edit"){
                        this.dataDropdownLevelEdit = res.data.data;
                        this.loadingDropdownLevelEdit = false;
                    }else if(purpose == null){
                        this.dataDropdownLevelFilter = res.data.data;
                        this.dataDropdownLevelAdd = res.data.data;
                        this.dataDropdownLevelEdit = res.data.data;
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
            }, 250);
        },
        // RESET
		resetItem(item) {
			this.item = item;
            
            this.$refs.reset.resetItemDialog = true;
		},
        // ADDNEW
        saveNew() {
            this.loadingAddNew = true;

            this.axios({
                method: 'POST',
                url: process.env.VUE_APP_ROOT_API + 'web/master-userweb/create',
                data: {
                    "userweb_username": this.forms.username,
                    "userweb_nama": this.forms.nama,
                    "level_id": this.forms.level_id,
                    "password": this.forms.password,
                },
            })
            .then((res) => {
                this.loadingAddNew = false;
                if (res) {
                    this.$toast.add({ severity: 'success', summary: 'Successful', detail: 'Data Berhasil Disimpan', life: 3000,});
                    this.$store.commit('setErrors', {});
                    this.$store.commit('setErrorAdd', {});
                    this.clearForms();
                    this.getDataTable();
                }
            })
            .catch((err) => {
                console.log(err);
                this.loadingAddNew = false;
                this.$store.commit('setErrorAdd', err.response.data.data);
                this.$toast.add({ severity: 'error', summary: 'Failed', detail: 'Data Gagal Disimpan', life: 3000,});
            });
        },
        clearForms() {
            this.forms.username = null;
            this.forms.nama = null;
            this.forms.level_id = null;
            this.forms.password = "viewer";
        },
        // EDIT
		editItem(item) {
			this.item = item;
            this.password= null;
            
            // dropdown 
            this.searchDropdownLevel('', 'edit', item.level_name);

			this.editItemDialog = true;
            this.$store.commit('setErrorEdit', {});

		},
		hideDialog() {
			this.editItemDialog = false;
			this.submitted = false;
		},
		updateItem() {
            this.loadingEdit = true;

            this.axios({
                method: 'POST',
                url: process.env.VUE_APP_ROOT_API + 'web/master-userweb/update',
                data: {
                    "userweb_id" : this.item.userweb_id,
                    "userweb_username" : this.item.userweb_username,
                    "userweb_nama" : this.item.userweb_nama,
                    "level_id" : this.item.level_id,
                    "password" : this.password ? this.password : null,
                    "status_" : this.item.status_,
                },
            })
            .then((res) => {
                this.loadingEdit = false;
                if (res) {
                    this.$toast.add({ severity: 'success', summary: 'Successful', detail: 'Data Berhasil Diupdate', life: 3000,});
                    this.$store.commit('setErrors', {});
                    this.$store.commit('setErrorEdit', {});
                    this.item = {};
                    this.editItemDialog = false;
                    this.getDataTable();
                }
            })
            .catch((err) => {
                console.log(err);
                this.loadingEdit = false;
                this.$store.commit('setErrorEdit', err.response.data.data);
                this.$toast.add({ severity: 'error', summary: 'Failed', detail: 'Data Gagal Diperbarui', life: 3000,});
            });
		},
        // DATATABLE
        getDataTable(){
          
            this.loading=true;
            this.page = (this.offset / this.rows) + 1;

            this.axios({
                method: 'GET',
                url: process.env.VUE_APP_ROOT_API + 'web/master-userweb',
                params: {
                    "search" : this.search,
                    "per_page" : this.rows,
                    "page" : this.page,
                    "order_by" : this.field,
                    "sort_by" : this.sort,
                    "level_id" : this.filters.level_id,
                }
            })
            .then(res => {
              this.data = res.data.data.data;
              this.dataTable = numberingDatatable(res.data.data.data, this.page, this.rows);
              this.totalItemsCount = res.data.data.total;
              this.rows = parseInt(res.data.data.per_page);
              this.loading=false;
            })
            .catch((err) => {
                console.log(err);
            });
         
        },
        onSort(event) {
            this.field = event.sortField;
            this.sort = event.sortOrder == '1' ? 'ASC' : 'DESC';
            this.getDataTable();
        },
        // EXPORT
        exportExcelCSV(ext){

            if(ext == 'xlsx'){
                this.loadingExcel=true;
            }else if(ext == 'csv'){
                this.loadingCsv=true;
            }

            this.axios({
            method: 'GET',
            url: process.env.VUE_APP_ROOT_API + 'web/master-userweb/export',
            responseType: 'blob',
            params: {
                "ext" : ext,
                "level_id" : this.filters.level_id,
            }
            })
            .then(response => {
                let fileUrl = window.URL.createObjectURL(response.data);
                let fileLink = document.createElement('a');

                fileLink.href = fileUrl;

                fileLink.setAttribute('download', 'Master User Web Export.' + ext);
                
                document.body.appendChild(fileLink)

                fileLink.click();
                
                if(ext == 'xlsx'){
                    this.loadingExcel=false;
                }else if(ext == 'csv'){
                    this.loadingCsv=false;
                }

            })
            .catch((err) => {
                console.log(err);
                
                if(ext == 'xlsx'){
                    this.loadingExcel=false;
                }else if(ext == 'csv'){
                    this.loadingCsv=false;
                }
            });
        },
    }
}
</script>
